import React from "react";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";

import { withStyles } from "@material-ui/core";
import { limparCpfCnpj } from "../_common/utils/cpfCnpj";

const placeholderChar = "\u2000";
export const cpf = [/\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/];
export const cnpj = [
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  ".",
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  ".",
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  "/",
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  /[0-9A-Za-z]/,
  "-",
  /\d/,
  /\d/,
];

const resolveMask = value => {
  const cleaned = limparCpfCnpj(value);
  return /[A-Za-z]/.test(cleaned) || cleaned.length > cpf.length - 3 ? cnpj : cpf;
};

const toUpperCase = conformedValue => conformedValue.toUpperCase();

function TextMaskCpfCnpj({ inputRef, ...other }) {
  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      placeholderChar={placeholderChar}
      guide={false}
      pipe={toUpperCase}
      mask={rawValue => {
        let val = rawValue || "";
        val = val.replace(/\s/g, "");
        return resolveMask(val);
      }}
    />
  );
}

TextMaskCpfCnpj.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export default withStyles({ root: {} })(TextMaskCpfCnpj);

export const cpfMask = (value = "") =>
  value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");

export const cnpjMask = (value = "") =>
  value?.toUpperCase().replace(/([0-9A-Z]{2})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{4})(\d{2})/g, "$1.$2.$3/$4-$5");
